<template>
  <div class="dashboard">
    <PageHeader />
    <PageContainer>
      <MainContent>
        <RouterView />
      </MainContent>
      <ContentSidebar>
        <PlansNavigation :model-value="$route.query.filter || 'all'" />
      </ContentSidebar>
    </PageContainer>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '@components/common/PageHeader.vue';
import PlansNavigation from '@components/navigation/PlansNavigation.vue';
import ContentSidebar from '@components/templates/ContentSidebar.vue';
import MainContent from '@components/templates/MainContent.vue';
import PageContainer from '@components/templates/PageContainer.vue';
import { RouterView } from 'vue-router';
</script>

<style>
.dashboard {
  display: flex;
  flex-direction: column;
  gap: var(--gap-md);
}
</style>
